/**
 * Chat Icon Button Component
 *
 * Header button for quick access to chat with unread message badge.
 * Only visible when user has canAccessChat permission.
 */

import React, { useCallback } from 'react';
import { Badge, Button } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { useChatStore } from '@municipality/chat';

const StyledBadge = styled(Badge)`
  .ant-scroll-number-only-unit {
    font-size: 10px !important;
  }
`;

export const ChatIconButton: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const unreadCount = useChatStore((state) => state.unreadCount);

  const handleClick = useCallback(() => {
    navigate('/chat');
  }, [navigate]);

  return (
    <StyledBadge count={unreadCount} offset={[-3, 3]}>
      <Button
        shape="circle"
        icon={<MessageOutlined />}
        onClick={handleClick}
        title={t('navigation.chat', 'Chat')}
        aria-label={t('navigation.chat', 'Chat')}
      />
    </StyledBadge>
  );
};

